<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">
          {{ $t('user.personal_info.title') }}
        </div>
        <span class="body-1 greyDarken1--text">Manage your profile</span>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        v-if="!is_editing"
        color="secondary"
        dark
        @click="is_editing = !is_editing"
        class="ma-0"
      >
        <v-icon small>$vuetify.icons.rms_edit</v-icon>
        &nbsp;{{ $t('rms.button.edit') }}
      </v-btn>
      <v-btn v-else color="secondary" dark @click="save()" class="ma-0">
        <v-icon small>$vuetify.icons.rms_save</v-icon>
        &nbsp;{{ $t('rms.button.save') }}
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-card>
        <v-card-text>
          <v-layout row wrap justify-center align-center>
            <v-flex xs12 md2 lg2>
              <v-layout column wrap justify-center align-center>
                <v-flex>
                  <div>
                    <avatar :size="150" :username="user.name"></avatar>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md10 lg10>
              <v-form ref="form" onsubmit="return false;">
                <v-text-field
                  :disabled="!is_editing"
                  v-model="user_name"
                  label="Name"
                  color="primary"
                  :rules="[
                    rules.required,
                    rules.min_length(3),
                    rules.max_length(50),
                  ]"
                  counter="50"
                ></v-text-field>
                <v-text-field
                  color="primary"
                  :value="user.email"
                  label="Email"
                  disabled
                ></v-text-field>
                <v-text-field
                  color="primary"
                  :value="user.phone"
                  disabled
                  label="Phone"
                ></v-text-field>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>
<script>
import DEFINES from '@/defines';
import {mapFields} from 'vuex-map-fields';
import {mapState, mapGetters} from 'vuex';
import i18n from '@/i18n';
import Avatar from 'vue-avatar';
import rules from '@/validation';
export default {
  name: 'UserProfile',
  components: {
    Avatar,
  },
  data() {
    return {
      rules,
      is_editing: false,
    };
  },

  computed: {
    ...mapFields('user', {
      user_name: 'profile.name',
    }),
    ...mapState({
      user: state => state.user.profile,
    }),
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      try {
        var response = await this.$store.dispatch('user/update', this.user);
        this.$store.dispatch('app/showMessage', {
          message: i18n.t('message.success.updated'),
          color: 'success',
        });
        this.is_editing = false;
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },
  },
};
</script>
